import React from "react"
import { EWsrvTransform, IMediaItem } from "../../lib";
import { ILinkFunc } from "../../lib/util";
import { Button } from "../Button";
import { WsrvImage } from "../Media";
import Heading from "./Heading";

export enum EColumnSizing {
    left25 = "left25",
    left40 = "left40",
    left50 = "left50",
    left60 = "left60",
}

export interface IColumn {
    image?: IMediaItem;
    imagePreset?: EWsrvTransform;
    title?: string;
    titleHeadingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
    text?: string;
    link?: { label?: string; url?: string };
}

export interface ITwoColumnLayoutProps {
    className?: string;
    title?: string;
    titleHeadingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
    columnsWrapperClass?: string;
    leftColumn: IColumn;
    rightColumn: IColumn;
    columnSizing: EColumnSizing;
    linkFunc?: ILinkFunc;
    scaleImageOnHover?: boolean;
}

export const TwoColumnTextLayoutBlade: React.FC<ITwoColumnLayoutProps> = ({
    className = "",
    linkFunc,
    title,
    titleHeadingLevel = "h1",
    columnsWrapperClass = "",
    leftColumn,
    rightColumn,
    columnSizing,
    scaleImageOnHover = false,
}) => {

    const linkf = linkFunc || ((props) => <a {...props} />);

    let leftColClass = "";
    let rightColClass = "";
    switch (columnSizing) {
        case EColumnSizing.left25:
            leftColClass = "lg:w-1/4";
            rightColClass = "lg:w-3/4";
            break;
        case EColumnSizing.left40:
            leftColClass = "lg:w-2/5";
            rightColClass = "lg:w-3/5";
            break;
        case EColumnSizing.left60:
            leftColClass = "lg:w-3/5";
            rightColClass = "lg:w-2/5";
            break;
        default:
            leftColClass = "lg:w-1/2";
            rightColClass = "lg:w-1/2";
            break;
    }

    return (
        <section className={`two-column-text ${className} relative w-full p-5`}>
            {title &&
                <Heading className="text-center" headingLevel={titleHeadingLevel}>{title}</Heading>
            }
            <div className={`relative mx-auto flex flex-row flex-wrap md:flex-nowrap w-full gap-10 ${columnsWrapperClass}`}>
                <div className={`${leftColClass} w-full md:w-1/2 !overflow-hidden`}>
                    {leftColumn.image &&
                        <WsrvImage
                            urlParams={{
                                originURL: leftColumn.image.url,
                                preset: leftColumn.imagePreset ?? EWsrvTransform.cover4x3,
                            }}
                            imgProps={{
                                className: `w-full object-cover h-full ${scaleImageOnHover ? 'transition duration-300 hover:scale-110' : ''}`,
                                wrapperClassName: "h-full"
                            }}
                        />
                    }
                    {leftColumn.title &&
                        <Heading
                            className="mb-2"
                            headingLevel={leftColumn.titleHeadingLevel || "h3"}
                        >
                            {leftColumn.title}
                        </Heading>}
                    {leftColumn.text && (
                        <div
                            dangerouslySetInnerHTML={{ __html: leftColumn.text }}
                        ></div>
                    )}
                    {leftColumn.link?.url &&
                        <Button
                            icon={false}
                            linkProps={{
                                href: leftColumn.link.url,
                                className: `normal-case italic font-normal mt-6`,
                            }}
                            linkFunc={linkf}
                        >
                            {leftColumn.link.label}
                        </Button>
                    }
                </div>
                <div className={`${rightColClass} w-full md:w-1/2 !overflow-hidden`}>
                    {rightColumn.image &&
                        <WsrvImage
                            urlParams={{
                                originURL: rightColumn.image.url,
                                preset: rightColumn.imagePreset ?? EWsrvTransform.cover4x3,
                            }}
                            imgProps={{
                                className: `w-full object-cover ${scaleImageOnHover ? 'transition duration-300 hover:scale-110' : ''}`
                            }}
                        />
                    }
                    {rightColumn.title &&
                        <Heading
                            className="mb-2"
                            headingLevel={rightColumn.titleHeadingLevel || "h3"}
                        >
                            {rightColumn.title}
                        </Heading>}
                    {rightColumn.text && (
                        <div
                            dangerouslySetInnerHTML={{ __html: rightColumn.text }}
                        ></div>
                    )}
                    {rightColumn.link?.url &&
                        <Button
                            icon={false}
                            linkProps={{
                                href: rightColumn.link.url,
                                className: `normal-case italic font-normal mt-6`,
                            }}
                            linkFunc={linkf}
                        >
                            {rightColumn.link.label}
                        </Button>
                    }
                </div>
            </div>
        </section>
    )
}

export default TwoColumnTextLayoutBlade

